export const MAX_NUM_OF_ATTACHMENTS_PER_EVENT = 30;
export const MAX_NUM_OF_ATTACHMENTS_PER_BOLO = 20;

// min size in bytes for multipart upload 5MB
export const MULTIPART_UPLOAD_MIN_SIZE = 5_242_880;
// max size in bytes to upload
export const MAX_UPLOAD_SIZE = 3_000_000_000;

// max concurrent part uploads for multipart upload (to avoid overwhelming browser connection pool)
export const MAX_CONCURRENT_PART_UPLOADS = 4;
// max age of attachment cache in seconds
export const ATTACHMENT_CACHE_MAX_AGE = 604800; // 7 days

// timeout for updateUploadProgress callback in milliseconds (websocket message was not received before timeout)
export const ATTACHMENT_CREATED_WEBSOCKET_MESSAGE_TIMEOUT_FOR_UPDATE_UPLOAD_PROGRESS = 30_000;

// commmon key for all attachments react-query queryKey
export const ATTACHMENTS_QUERY_KEY = 'attachments';

export const ATTACHMENT_SORT_OPTIONS = [
    { value: 'uploadDate-newest' as const, category: 'Upload Date', label: 'Newest - Oldest' },
    { value: 'uploadDate-oldest' as const, category: 'Upload Date', label: 'Oldest - Newest' },
    { value: 'name-az' as const, category: 'Name', label: 'A - Z' },
    { value: 'name-za' as const, category: 'Name', label: 'Z - A' },
    { value: 'size-largest' as const, category: 'Size', label: 'Largest - Smallest' },
    { value: 'size-smallest' as const, category: 'Size', label: 'Smallest - Largest' },
] as const;

// Default sort option for attachments
export const DEFAULT_ATTACHMENT_SORT_OPTION_VALUE = 'uploadDate-newest' as const;

// File type extensions for determining attachment types
export const IMAGE_FILE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'] as const;
export const VIDEO_FILE_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv'] as const;
export const AUDIO_FILE_EXTENSIONS = ['mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac', 'wma'] as const;
export const PDF_FILE_EXTENSION = 'pdf' as const;
